<template>
  <div id="app">
    <div class="app-content">
      <div class="router-outlet">
        <router-view :key="$route.path" />
      </div>
      <app-footer />
    </div>
  </div>
</template>

<script>
  import AppFooter from "./components/Footer";
  import { CATEGORY } from './store/actions';

  export default {
    name: "App",
    components: {
      AppFooter
    },
    async mounted() {
      try {
        await this.$store.dispatch(`category/${CATEGORY.GET_ALL}`);
      } catch (e) {
        // TODO display message?
        console.error("Error getting categories", e);
      }
    }
  };
</script>

<style lang="scss">
  html,
  body {
    margin: 0;
    padding: 0;
  }

  #app {
    display: flex;
    flex-direction: column;
    height: 100%;
    font-family: "Open Sans", Arial, Helvetica, sans-serif;
    font-size: 14px;
    color: $color-black;

    .app-content {
      display: flex;
      flex-direction: column;
      flex-grow: 1;

      .router-outlet {
        flex-grow: 1;

        > * {
          width: 100%;
          box-sizing: border-box;
        }
      }
    }
  }
</style>
